import { useItem } from './hooks/use-context';
import moment from 'moment';

export function ActionPlan() {
  const { sections } = useItem();
  const questions = sections.flatMap((section) => section.questions);

  const getAnswerFor = (prefix: string, idNum: string) => {
    const textToMatch = `${prefix} ID: ${idNum}`.toLowerCase();
    const q = questions.find((q) => q.name.toLowerCase().includes(textToMatch));
    if (!q || !q.answers || q.answers.length === 0) return '';
    return q.answers[0].content || q.answers[0].option || '';
  };

  const rows = ['01', '02', '03'].map((id) => {
    const prazo = getAnswerFor('Informe o prazo da ação', id);
    const parsedPrazo = prazo.includes('/') ? prazo : (prazo ? moment(prazo).format('DD/MM/YYYY') : '');
    
    return {
      id,
      acao: getAnswerFor('Informe a ação', id) || getAnswerFor('procedimento', id),
      responsavel: getAnswerFor('Informe o responsável da ação', id),
      prazo: parsedPrazo,
    };
  });

  const theadStyle = { borderBottom: '1px solid #000', display: 'flex', fontWeight: 'bold' as const };
  const rowStyle = { borderBottom: '1px solid #000', display: 'flex', minHeight: '30px' };
  const colId = { width: '40px', padding: '4px', borderRight: '1px solid #000', textAlign: 'center' as const };
  const colAcao = { flex: 1, padding: '4px', borderRight: '1px solid #000' };
  const colResp = { width: '150px', padding: '4px', borderRight: '1px solid #000', textAlign: 'center' as const };
  const colPrazo = { width: '100px', padding: '4px', textAlign: 'center' as const };

  return (
    <div style={{ color: '#000', fontSize: '13px', lineHeight: '1.5', fontFamily: 'sans-serif' }}>
      <div style={{ backgroundColor: '#D9D9D9', padding: '4px', fontWeight: 'bold', marginBottom: '8px', fontSize: '14px' }}>
        3- PLANO DE AÇÃO
      </div>
      
      <div style={{ border: '1px solid #000', borderBottom: 'none', marginBottom: '24px' }}>
        <div style={theadStyle}>
          <div style={colId}>ID</div>
          <div style={colAcao}>Ação</div>
          <div style={colResp}>Responsável</div>
          <div style={colPrazo}>Prazo</div>
        </div>
        
        {rows.map((row) => (
          <div key={row.id} style={rowStyle}>
            <div style={colId}>{row.id}</div>
            <div style={colAcao}>{row.acao}</div>
            <div style={colResp}>{row.responsavel}</div>
            <div style={colPrazo}>{row.prazo}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
